import { revalidate as apiRevalidate } from '@troon/api-client';
import type { CacheablePaths } from '@troon/api-client';
import type { OperationNames } from './__generated__/operations';

export type CacheKey = OperationNames | CacheablePaths;

/**
 * Revalidate cached data.
 * This is a wrapper around Solid Router’s `revalidate()` method that also clears the client’s local
 * in-memory TTL cache.
 */
export async function revalidate(
	/**
	 * The cache key or keys to revalidat.
	 * Sending `undefined` for this value is equivalent to revalidating _all_ cached data.
	 * An empty array will revalidate nothing.
	 */
	key?: CacheKey | CacheablePaths | Array<CacheKey | CacheablePaths> | void,
	/**
	 * Forces Solid Router to trigger a cache miss on the key
	 */
	force?: boolean,
) {
	// @ts-expect-error we are overloading things here for backwards compat
	return apiRevalidate(key, force);
}
